import { ProductItemSkeleton } from '@/components/ProductItemSkeleton/ProductItemSkeleton'
import { Skeleton } from '@/components/Skeleton/Skeleton'
import { yStack } from 'ui/src/patterns/stack'
import { buttonSkeleton, expandedProductItemSkeleton, infoCardSkeleton } from './LoadingSkeleton.css'

export const LoadingSkeleton = () => {
  return (
    <div className={yStack({ gap: 'md' })}>
      <ProductItemSkeleton />
      <Skeleton className={expandedProductItemSkeleton} />
      <Skeleton className={infoCardSkeleton} />
      <Skeleton className={buttonSkeleton} />
    </div>
  )
}
